// import React, { useState } from "react";
// import CampaignDetails from "./CampaignDetails";
// import MessageStep from "./MessageStep";
// import ReviewStep from "./ReviewStep";
// import SummaryCard from "./SummaryCard";
// import { Container, Button, ProgressBar } from "react-bootstrap";

// const CreateCampaign = () => {
//   const [step, setStep] = useState(1);
//   const [campaignData, setCampaignData] = useState({
//     name: "",
//     targetAudience: "",
//     phoneNumbers: [],
//     messageTemplate: "",
//   });

//   const nextStep = () => setStep((prevStep) => prevStep + 1);
//   const prevStep = () => setStep((prevStep) => prevStep - 1);

//   return (
//     <Container className="mt-4">
//       <h2>Create Campaign</h2>
//       <ProgressBar now={(step / 3) * 100} className="mb-4" />

//       {step === 1 && (
//         <CampaignDetails data={campaignData} setData={setCampaignData} nextStep={nextStep} />
//       )}
//       {step === 2 && (
//         <MessageStep data={campaignData} setData={setCampaignData} nextStep={nextStep} prevStep={prevStep} />
//       )}
//       {step === 3 && <ReviewStep data={campaignData} prevStep={prevStep} />}
//     </Container>
//   );
// };

// export default CreateCampaign;


import React, { useState, useEffect, useRef } from "react";
import CampaignDetails from "./CampaignDetails";
import MessageStep from "./MessageStep";
import ReviewStep from "./ReviewStep";
import SummaryCard from "./SummaryCard";
import { Container, ProgressBar, Row, Col, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "config.js";

const CreateCampaign = () => {
  const navigate = useNavigate();
  const prevUrlDraftIdRef = useRef(null);
  const [step, setStep] = useState(1);
  const [isProcessing, setIsProcessing] = useState(false);
  const [userForceTest, setUserForceTest] = useState(false);
  const [credits, setCredits] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("user"));
      return stored?.credits || 0;
    } catch {
      return 0;
    }
  });
  const [campaignData, setCampaignData] = useState({
    name: "",
    contactListId: "",
    contactListName: "",
    messageTemplate: "",
    contactListCount: 0,
    draftId: null,
    campaignType: "broadcast",
    messagesPerNumber: "", // "" = untouched (triggers warning); null = opted out; number = set
    phoneNumbers: [],
    approvalStatus: "none",
    testSent: false,
  });

  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = localStorage.getItem("token");
        console.log("CreateCampaign fetchData on mount. storedUser:", storedUser?.id || storedUser?._id, "token:", !!token);
        if (!storedUser || !token) return;

        const headers = { Authorization: `Bearer ${token}` };
        const userId = storedUser.id || storedUser._id;

        // Fetch credits
        const res = await axios.get(`${API_BASE_URL}/users/${userId}`, { headers });
        console.log("CreateCampaign fetch credits success:", res.data.success);
        if (res.data.success) {
          setCredits(res.data.data.credits || 0);
          setUserForceTest(res.data.data.forceTestMessage || false);
        }

        // Check for draftId
        const params = new URLSearchParams(location.search);
        const draftId = params.get("draftId");
        console.log("CreateCampaign fetch draft check. draftId:", draftId, "step:", step);
        if (draftId && step === 1) {
          console.log("Fetching draft campaign:", draftId);
          const draftRes = await axios.get(`${API_BASE_URL}/campaigns/${draftId}`, { headers });
          console.log("Fetch draft campaign response:", draftRes.data.success, draftRes.data.campaign?.name);
          if (draftRes.data.success && draftRes.data.campaign) {
            const draft = draftRes.data.campaign;

            // Strip compliance option suffix if it exists to avoid duplication
            let baseMessage = draft.messageBody || "";
            const compOpt = draft.complianceOption || "Reply STOP to unsubscribe";
            if (compOpt && compOpt.toLowerCase() !== "none" && baseMessage.endsWith(`\n\n${compOpt}`)) {
              baseMessage = baseMessage.slice(0, -(compOpt.length + 2));
            }

            let mediaId = null;
            if (draft.mediaUrl && draft.mediaUrl.includes("/media/proxy/")) {
              const parts = draft.mediaUrl.split("/");
              mediaId = parts[parts.length - 1];
            }

            setCampaignData(prev => ({
              ...prev,
              name: draft.name || "",
              contactListId: draft.contactListId?._id || draft.contactListId || "",
              contactListName: draft.contactListId?.listName || draft.contactListId?.name || "",
              messageTemplate: baseMessage,
              contactListCount: draft.contactListId?.countContact || 0,
              campaignType: draft.campaignType || "broadcast",
              draftId: draft._id,
              phoneNumbers: (draft.phoneNumbers || []).map(n => typeof n === 'object' && n !== null ? n._id : n),
              messagesPerNumber: draft.messagesPerNumber !== undefined ? draft.messagesPerNumber : "",
              approvalStatus: draft.approvalStatus || "none",
              mediaUrl: draft.mediaUrl || null,
              mediaId: mediaId,
              mediaMimeType: null,
              complianceOption: draft.complianceOption || "Reply STOP to unsubscribe",
              testSent: draft.testSent || false,
            }));
            setStep(2); // Jump to Step 2 (Message Composition) instead of Step 3 (Review)
          }
        }
      } catch (err) {
        console.error("Error fetching data in CreateCampaign:", err);
      }
    };
    fetchData();
  }, [location.search]);

  useEffect(() => {
    if (campaignData.draftId) {
      const params = new URLSearchParams(location.search);
      if (params.get("draftId") !== campaignData.draftId) {
        params.set("draftId", campaignData.draftId);
        navigate({ search: params.toString() }, { replace: true });
      }
    }
  }, [campaignData.draftId, location.search, navigate]);

  // Handle clearing state when starting a new campaign from the sidebar
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlDraftId = params.get("draftId");
    
    // We want to clear state when navigating to the base /campaigns/create route 
    // without a draft ID. This handles both cross-contamination from a previous draft
    // and clicking the sidebar link while already on an active (but unsaved) draft.
    if (!urlDraftId) {
      setCampaignData({
        name: "",
        contactListId: "",
        contactListName: "",
        messageTemplate: "",
        contactListCount: 0,
        draftId: null,
        campaignType: "broadcast",
        messagesPerNumber: "",
        phoneNumbers: [],
        approvalStatus: "none",
        mediaUrl: null,
        mediaId: null,
        mediaMimeType: null,
        complianceOption: "Reply STOP to unsubscribe",
        testSent: false,
      });
      setStep(1);
    }
  }, [location.key]);

  const nextStep = () => setStep((prevStep) => prevStep + 1);
  const prevStep = () => setStep((prevStep) => prevStep - 1);

  // Prepare summary data based on campaignData
  // const summaryData = [
  //   { label: "Campaign Name", value: campaignData.name || "Not Provided" },
  //   { label: "Target Audience", value: campaignData.targetAudience || "Not Selected" },
  //   { label: "Selected Phone Numbers", value: `${campaignData.phoneNumbers.length} Contacts` },
  //   { label: "Message Template", value: campaignData.messageTemplate || "Not Provided" },
  // ];

  return (
    <Container className="mt-4">
      {isProcessing && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            backdropFilter: "blur(4px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <Spinner animation="border" variant="primary" style={{ width: "3.5rem", height: "3.5rem" }} />
          <h4 className="mt-3 text-dark fw-bold">Processing Request, Please Wait...</h4>
        </div>
      )}
      <h2 style={{ fontWeight: "700" }}>Create Campaign</h2>
      <p style={{ color: "#6c757d", fontSize: "16px", marginBottom: "1.5rem", fontWeight:"700" }}>
        Configure your messaging campaign
      </p>

      <div className="d-flex align-items-center mb-4">
        {["Campaign Details", "Message", "Review"].map((label, index) => {
          const stepNumber = index + 1;
          const isCompleted = step > stepNumber;
          const isActive = step === stepNumber;
          const isUpcoming = step < stepNumber;

          const circleBgColor = isActive || isCompleted ? "#004992" : "#D3D3D3";
          const circleTextColor = isActive || isCompleted ? "#FFF" : "#5e5e5e";
          const labelColor = isActive || isCompleted ? "#004992" : "#5e5e5e";

          // Color for the connecting line: blue if this step or next one is active
          const connectorColor = step > stepNumber ? "#004992" : "#D3D3D3";

          return (
            <div key={index} className="d-flex align-items-center">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center me-2"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: circleBgColor,
                  color: circleTextColor,
                  fontWeight: "bold",
                  marginRight: "10px",
                }}
              >
                {stepNumber}
              </div>
              <span
                style={{
                  marginRight: "20px",
                  color: labelColor,
                  fontWeight: 600,
                }}
              >
                {label}
              </span>
              {stepNumber < 3 && (
                <div
                  className="me-2"
                  style={{
                    borderTop: `3px solid ${connectorColor}`,
                    width: "50px",
                    marginRight: "20px",
                  }}
                />
              )}
            </div>
          );
        })}

      </div>

      <Row>
      <Col lg={8} sm={7} xs={12} className="p-3">
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "25px 30px",
            boxShadow: "0 1px 6px rgba(0,0,0,0.1)",
            position: "relative",
          }}
        >
            {/* <Col lg={8} sm={7} xs={12} className="p-3"> */}
              {step === 1 && (
                <CampaignDetails data={campaignData} setData={setCampaignData} nextStep={nextStep} isProcessing={isProcessing} setIsProcessing={setIsProcessing} />
              )}
              {step === 2 && (
                <MessageStep data={campaignData} setData={setCampaignData} nextStep={nextStep} prevStep={prevStep} setCredits={setCredits} userForceTest={userForceTest} isProcessing={isProcessing} setIsProcessing={setIsProcessing} />
              )}
              {step === 3 && <ReviewStep data={campaignData} prevStep={prevStep} credits={credits} userForceTest={userForceTest} />}
          </div>
        </Col>
        <Col lg={4} sm={5} xs={12} className="p-3">
          <SummaryCard
            campaignData={campaignData}
            credits={credits}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default CreateCampaign;
